module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "logo-3.8e07ebe5.svg";